// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Leaflet Machine Marker Styles */
.pin-wrapper {
  position: relative;
  width: 40px;
  height: 55px;
  transform: translate(-50%, -100%);
}

.pin-circle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 4px rgba(0,0,0,0.4);
}

.pin-tail {
  position: absolute;
  left: 50%;
  bottom: 5px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  transform: translateX(-50%);
}

.pin-icon {
  position: absolute;
  width: 34px;
  height: 34px;
  top: 3px;
  left: 50%;
  transform: translateX(-50%);
  filter: brightness(0) invert(1);
  pointer-events: none;
  object-fit: contain;
}

/* Dark Mode Global Support & PrimeReact overrides */
[data-theme='dark'] body,
body[data-theme='dark'] {
  background-color: #0f1719;
  color: #f1f5f9;
}

/* PrimeReact Dropdown Dark Mode */
[data-theme='dark'] .tele-dropdown,
[data-theme='dark'] .p-dropdown {
  background-color: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.16) !important;
  color: #f1f5f9 !important;
}

[data-theme='dark'] .tele-dropdown .p-dropdown-label,
[data-theme='dark'] .p-dropdown .p-dropdown-label {
  color: #f1f5f9 !important;
}

[data-theme='dark'] .tele-dropdown .p-dropdown-trigger,
[data-theme='dark'] .p-dropdown .p-dropdown-trigger {
  color: #94a3b8 !important;
}

[data-theme='dark'] .tele-dropdown-label,
[data-theme='dark'] .p-float-label label {
  color: #94a3b8 !important;
}

[data-theme='dark'] .tele-dropdown-panel,
[data-theme='dark'] .p-dropdown-panel {
  background-color: #172328 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6) !important;
}

[data-theme='dark'] .tele-dropdown-panel .p-dropdown-item,
[data-theme='dark'] .p-dropdown-panel .p-dropdown-item {
  color: #f1f5f9 !important;
}

[data-theme='dark'] .tele-dropdown-panel .p-dropdown-item:hover,
[data-theme='dark'] .p-dropdown-panel .p-dropdown-item:hover,
[data-theme='dark'] .p-dropdown-panel .p-dropdown-item.p-highlight {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #ffffff !important;
}

[data-theme='dark'] .p-dropdown-panel .p-dropdown-header,
[data-theme='dark'] .tele-dropdown-panel .p-dropdown-header,
[data-theme='dark'] .p-dropdown-header,
[data-theme='dark'] .p-multiselect-panel .p-multiselect-header,
[data-theme='dark'] .p-multiselect-header,
body[data-theme='dark'] .p-dropdown-panel .p-dropdown-header,
body[data-theme='dark'] .tele-dropdown-panel .p-dropdown-header,
body[data-theme='dark'] .p-dropdown-header,
body[data-theme='dark'] .p-multiselect-panel .p-multiselect-header,
body[data-theme='dark'] .p-multiselect-header {
  background: #172328 !important;
  background-color: #172328 !important;
  color: #f1f5f9 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter,
[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter,
body[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter,
body[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter {
  background-color: #243238 !important;
  color: #f1f5f9 !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  border-radius: 4px !important;
  padding: 6px 10px !important;
  outline: none !important;
}

[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter::placeholder,
[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter::placeholder,
body[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter::placeholder,
body[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter::placeholder {
  color: #8fa3ad !important;
  opacity: 0.85 !important;
}

[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter:focus,
[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter:focus,
body[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter:focus,
body[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter:focus {
  background-color: #2c3b42 !important;
  border-color: #38bdf8 !important;
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25) !important;
}

[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter-icon,
[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter-icon,
body[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter-icon,
body[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter-icon {
  color: #8fa3ad !important;
}

[data-theme='dark'] .p-dropdown-clearable-filter .p-dropdown-filter-clear-icon,
body[data-theme='dark'] .p-dropdown-clearable-filter .p-dropdown-filter-clear-icon {
  color: #8fa3ad !important;
}

/* PrimeReact Calendar Dark Mode */
[data-theme='dark'] .p-datepicker {
  background-color: #172328 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  color: #f1f5f9 !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6) !important;
}

[data-theme='dark'] .p-datepicker table th,
[data-theme='dark'] .p-datepicker table td > span {
  color: #f1f5f9 !important;
}

[data-theme='dark'] .p-datepicker .p-datepicker-header {
  background-color: #172328 !important;
  color: #f1f5f9 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
}

[data-theme='dark'] .p-datepicker table td > span:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* Dark scrollbars */
[data-theme='dark'] ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

[data-theme='dark'] ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
}

[data-theme='dark'] ::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

[data-theme='dark'] ::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}

/* Native Leaflet Dark Theme via CSS filters (No external tile providers or API keys needed) */
[data-theme='dark'] .leaflet-tile-pane {
  filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%);
}

[data-theme='dark'] .no-map-dark-filter .leaflet-tile-pane {
  filter: none !important;
}

[data-theme='dark'] .leaflet-container {
  background-color: #0b1114 !important;
}

[data-theme='dark'] .leaflet-bar a {
  background-color: #162328 !important;
  color: #f1f5f9 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}

[data-theme='dark'] .leaflet-bar a:hover {
  background-color: #23373e !important;
  color: #ffffff !important;
}

[data-theme='dark'] .leaflet-control-attribution {
  background-color: rgba(16, 26, 30, 0.8) !important;
  color: #94a3b8 !important;
}

[data-theme='dark'] .leaflet-control-attribution a {
  color: #38bdf8 !important;
}

[data-theme='dark'] .leaflet-control-layers {
  background-color: #162328 !important;
  color: #f1f5f9 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5) !important;
}

[data-theme='dark'] .leaflet-control-layers-toggle {
  filter: brightness(0.9) invert(0.9);
}

[data-theme='dark'] .leaflet-popup-content-wrapper,
[data-theme='dark'] .leaflet-popup-tip {
  background-color: #162328 !important;
  color: #f1f5f9 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

[data-theme='dark'] .leaflet-container a.leaflet-popup-close-button {
  color: #94a3b8 !important;
}

/* DataTables Column Filter Inputs - Base / Light Mode */
.table-column-filter,
table.dataTable thead th input,
table.dataTable thead td input,
.dataTables_wrapper thead input {
  display: block;
  box-sizing: border-box !important;
  width: 100% !important;
  margin-top: 6px !important;
  padding: 4px 8px !important;
  font-size: 12px !important;
  font-family: inherit !important;
  line-height: 1.4 !important;
  border-radius: 4px !important;
  border: 1px solid #cbd5e1 !important;
  background-color: #ffffff !important;
  color: #1e293b !important;
  outline: none !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background-color 0.15s ease-in-out !important;
}

.table-column-filter::placeholder,
table.dataTable thead th input::placeholder,
table.dataTable thead td input::placeholder,
.dataTables_wrapper thead input::placeholder {
  color: #94a3b8 !important;
  opacity: 1 !important;
}

.table-column-filter:focus,
table.dataTable thead th input:focus,
table.dataTable thead td input:focus,
.dataTables_wrapper thead input:focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2) !important;
}

/* DataTables Column Filter Inputs - Dark Mode Grayish Theme */
[data-theme='dark'] .table-column-filter,
[data-theme='dark'] table.dataTable thead th input,
[data-theme='dark'] table.dataTable thead td input,
[data-theme='dark'] .dataTables_wrapper thead input,
[data-theme='dark'] .dataTables_wrapper .dataTables_filter input,
[data-theme='dark'] input[placeholder="filtro"],
body[data-theme='dark'] .table-column-filter,
body[data-theme='dark'] table.dataTable thead th input,
body[data-theme='dark'] table.dataTable thead td input,
body[data-theme='dark'] .dataTables_wrapper thead input,
body[data-theme='dark'] input[placeholder="filtro"] {
  background-color: #243238 !important;
  color: #f1f5f9 !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  padding: 4px 8px !important;
  font-size: 12px !important;
  outline: none !important;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25) !important;
  transition: border-color 0.15s ease-in-out, background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

[data-theme='dark'] .table-column-filter::placeholder,
[data-theme='dark'] table.dataTable thead th input::placeholder,
[data-theme='dark'] table.dataTable thead td input::placeholder,
[data-theme='dark'] .dataTables_wrapper thead input::placeholder,
[data-theme='dark'] .dataTables_wrapper .dataTables_filter input::placeholder,
[data-theme='dark'] input[placeholder="filtro"]::placeholder,
body[data-theme='dark'] input[placeholder="filtro"]::placeholder {
  color: #8fa3ad !important;
  opacity: 0.85 !important;
}

[data-theme='dark'] .table-column-filter:hover,
[data-theme='dark'] table.dataTable thead th input:hover,
[data-theme='dark'] table.dataTable thead td input:hover,
[data-theme='dark'] .dataTables_wrapper thead input:hover,
[data-theme='dark'] .dataTables_wrapper .dataTables_filter input:hover,
[data-theme='dark'] input[placeholder="filtro"]:hover,
body[data-theme='dark'] input[placeholder="filtro"]:hover {
  background-color: #2c3b42 !important;
  border-color: rgba(255, 255, 255, 0.28) !important;
}

[data-theme='dark'] .table-column-filter:focus,
[data-theme='dark'] table.dataTable thead th input:focus,
[data-theme='dark'] table.dataTable thead td input:focus,
[data-theme='dark'] .dataTables_wrapper thead input:focus,
[data-theme='dark'] .dataTables_wrapper .dataTables_filter input:focus,
[data-theme='dark'] input[placeholder="filtro"]:focus,
body[data-theme='dark'] input[placeholder="filtro"]:focus {
  background-color: #31444e !important;
  border-color: #38bdf8 !important;
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25) !important;
  color: #ffffff !important;
}

/* DataTables Wrapper Controls in Dark Mode */
[data-theme='dark'] .dataTables_wrapper .dataTables_length select,
body[data-theme='dark'] .dataTables_wrapper .dataTables_length select {
  background-color: #243238 !important;
  color: #f1f5f9 !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  border-radius: 4px !important;
  padding: 3px 6px !important;
  outline: none !important;
}

[data-theme='dark'] .dataTables_wrapper .dataTables_length,
[data-theme='dark'] .dataTables_wrapper .dataTables_filter,
[data-theme='dark'] .dataTables_wrapper .dataTables_info,
[data-theme='dark'] .dataTables_wrapper .dataTables_processing,
[data-theme='dark'] .dataTables_wrapper .dataTables_paginate {
  color: #94a3b8 !important;
}

[data-theme='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button {
  color: #cbd5e1 !important;
}

[data-theme='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.current,
[data-theme='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
  background: #243238 !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
}

[data-theme='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid transparent !important;
  color: #ffffff !important;
}

[data-theme='dark'] table.dataTable thead th,
[data-theme='dark'] table.dataTable thead td {
  color: #f1f5f9 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}

[data-theme='dark'] table.dataTable tbody tr {
  background-color: transparent !important;
  color: #e2e8f0 !important;
}

[data-theme='dark'] table.dataTable.stripe tbody tr.odd,
[data-theme='dark'] table.dataTable.display tbody tr.odd {
  background-color: rgba(255, 255, 255, 0.02) !important;
}

[data-theme='dark'] table.dataTable.hover tbody tr:hover,
[data-theme='dark'] table.dataTable.display tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.06) !important;
}

/* Timeline and Dashboard Filters - Base / Light Mode */
.timeline-filter-input,
.timeline-date-input {
  box-sizing: border-box;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  color: #1e293b;
  outline: none;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background-color 0.15s ease-in-out;
}

.timeline-filter-input::placeholder {
  color: #94a3b8;
  opacity: 1;
}

.timeline-filter-input:focus,
.timeline-date-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.timeline-date-label {
  color: #64748b;
}

/* Timeline and Dashboard Filters - Dark Mode Grayish Theme */
[data-theme='dark'] .timeline-filter-input,
[data-theme='dark'] .timeline-date-input,
[data-theme='dark'] input[placeholder*="Filtrar máquinas"],
[data-theme='dark'] input[placeholder*="filtrar máquinas"],
body[data-theme='dark'] .timeline-filter-input,
body[data-theme='dark'] .timeline-date-input,
body[data-theme='dark'] input[placeholder*="Filtrar máquinas"],
body[data-theme='dark'] input[placeholder*="filtrar máquinas"] {
  background-color: #243238 !important;
  color: #f1f5f9 !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  border-radius: 4px !important;
  outline: none !important;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25) !important;
  transition: border-color 0.15s ease-in-out, background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

[data-theme='dark'] .timeline-filter-input::placeholder,
[data-theme='dark'] input[placeholder*="Filtrar máquinas"]::placeholder,
[data-theme='dark'] input[placeholder*="filtrar máquinas"]::placeholder,
body[data-theme='dark'] .timeline-filter-input::placeholder,
body[data-theme='dark'] input[placeholder*="Filtrar máquinas"]::placeholder,
body[data-theme='dark'] input[placeholder*="filtrar máquinas"]::placeholder {
  color: #8fa3ad !important;
  opacity: 0.85 !important;
}

[data-theme='dark'] .timeline-filter-input:hover,
[data-theme='dark'] .timeline-date-input:hover,
[data-theme='dark'] input[placeholder*="Filtrar máquinas"]:hover,
[data-theme='dark'] input[placeholder*="filtrar máquinas"]:hover,
body[data-theme='dark'] .timeline-filter-input:hover,
body[data-theme='dark'] .timeline-date-input:hover,
body[data-theme='dark'] input[placeholder*="Filtrar máquinas"]:hover,
body[data-theme='dark'] input[placeholder*="filtrar máquinas"]:hover {
  background-color: #2c3b42 !important;
  border-color: rgba(255, 255, 255, 0.28) !important;
}

[data-theme='dark'] .timeline-filter-input:focus,
[data-theme='dark'] .timeline-date-input:focus,
[data-theme='dark'] input[placeholder*="Filtrar máquinas"]:focus,
[data-theme='dark'] input[placeholder*="filtrar máquinas"]:focus,
body[data-theme='dark'] .timeline-filter-input:focus,
body[data-theme='dark'] .timeline-date-input:focus,
body[data-theme='dark'] input[placeholder*="Filtrar máquinas"]:focus,
body[data-theme='dark'] input[placeholder*="filtrar máquinas"]:focus {
  background-color: #31444e !important;
  border-color: #38bdf8 !important;
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25) !important;
  color: #ffffff !important;
}

[data-theme='dark'] .timeline-date-label,
body[data-theme='dark'] .timeline-date-label {
  color: #94a3b8 !important;
}

[data-theme='dark'] input[type="date"]::-webkit-calendar-picker-indicator,
body[data-theme='dark'] input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.8);
  cursor: pointer;
}

/* react-data-table-component Dark Mode */
[data-theme='dark'] .rdt_Table,
body[data-theme='dark'] .rdt_Table {
  background-color: transparent !important;
  color: #f1f5f9 !important;
}

[data-theme='dark'] .rdt_TableHead,
body[data-theme='dark'] .rdt_TableHead {
  background-color: transparent !important;
  color: #f1f5f9 !important;
}

[data-theme='dark'] .rdt_TableHeadRow,
body[data-theme='dark'] .rdt_TableHeadRow {
  background-color: rgba(255, 255, 255, 0.05) !important;
  color: #f1f5f9 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}

[data-theme='dark'] .rdt_TableHeadRow div,
[data-theme='dark'] .rdt_TableHeadRow span,
[data-theme='dark'] .rdt_TableHeadRow p,
body[data-theme='dark'] .rdt_TableHeadRow div,
body[data-theme='dark'] .rdt_TableHeadRow span,
body[data-theme='dark'] .rdt_TableHeadRow p {
  color: #f1f5f9 !important;
}

[data-theme='dark'] .rdt_TableBody,
body[data-theme='dark'] .rdt_TableBody {
  background-color: transparent !important;
}

[data-theme='dark'] .rdt_TableRow,
body[data-theme='dark'] .rdt_TableRow {
  background-color: #162328 !important;
  color: #e2e8f0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
}

[data-theme='dark'] .rdt_TableRow:nth-of-type(even),
body[data-theme='dark'] .rdt_TableRow:nth-of-type(even) {
  background-color: #131e23 !important;
}

[data-theme='dark'] .rdt_TableRow:hover,
body[data-theme='dark'] .rdt_TableRow:hover {
  background-color: #1e2e34 !important;
  color: #ffffff !important;
}

[data-theme='dark'] .rdt_TableCell,
body[data-theme='dark'] .rdt_TableCell {
  color: #e2e8f0 !important;
}

[data-theme='dark'] .rdt_TableCell div,
[data-theme='dark'] .rdt_TableCell span,
[data-theme='dark'] .rdt_TableCell p,
body[data-theme='dark'] .rdt_TableCell div,
body[data-theme='dark'] .rdt_TableCell span,
body[data-theme='dark'] .rdt_TableCell p {
  color: inherit;
}

[data-theme='dark'] .rdt_Pagination,
body[data-theme='dark'] .rdt_Pagination {
  background-color: #162328 !important;
  color: #94a3b8 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.08) !important;
}

[data-theme='dark'] .rdt_Pagination svg,
body[data-theme='dark'] .rdt_Pagination svg {
  fill: #cbd5e1 !important;
}

[data-theme='dark'] .rdt_Pagination button,
body[data-theme='dark'] .rdt_Pagination button {
  color: #cbd5e1 !important;
}

[data-theme='dark'] .rdt_Pagination button:disabled svg,
body[data-theme='dark'] .rdt_Pagination button:disabled svg {
  fill: rgba(255, 255, 255, 0.25) !important;
}

[data-theme='dark'] .rdt_Pagination select,
body[data-theme='dark'] .rdt_Pagination select {
  background-color: #243238 !important;
  color: #f1f5f9 !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  border-radius: 4px !important;
  padding: 3px 6px !important;
  outline: none !important;
}




`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;;EAEE,sDAAsD;EACtD,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,sDAAsD;EACtD,qDAAqD;AACvD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA;;;;EAIE,oCAAoC;EACpC,yBAAyB;EACzB,sDAAsD;EACtD,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;;;;EAIE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,sDAAsD;EACtD,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,qDAAqD;AACvD;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,8FAA8F;AAC9F;EACE,qEAAqE;AACvE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,sDAAsD;EACtD,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;;;;EAIE,cAAc;EACd,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB;EACxB,uHAAuH;AACzH;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,8DAA8D;AAC9D;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;EACzB,sDAAsD;EACtD,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,0DAA0D;EAC1D,uHAAuH;AACzH;;AAEA;;;;;;;EAOE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,oCAAoC;EACpC,kDAAkD;AACpD;;AAEA;;;;;;;EAOE,oCAAoC;EACpC,gCAAgC;EAChC,yDAAyD;EACzD,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,sDAAsD;EACtD,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA,uDAAuD;AACvD;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,4GAA4G;AAC9G;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;;;;;;;;EAQE,oCAAoC;EACpC,yBAAyB;EACzB,sDAAsD;EACtD,6BAA6B;EAC7B,wBAAwB;EACxB,0DAA0D;EAC1D,uHAAuH;AACzH;;AAEA;;;;;;EAME,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;;;;;;;EAQE,oCAAoC;EACpC,kDAAkD;AACpD;;AAEA;;;;;;;;EAQE,oCAAoC;EACpC,gCAAgC;EAChC,yDAAyD;EACzD,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;;EAEE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,sDAAsD;EACtD,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,sDAAsD;EACtD,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;AAC1B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Leaflet Machine Marker Styles */\n.pin-wrapper {\n  position: relative;\n  width: 40px;\n  height: 55px;\n  transform: translate(-50%, -100%);\n}\n\n.pin-circle {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  transform: translateX(-50%);\n  box-shadow: 0 0 4px rgba(0,0,0,0.4);\n}\n\n.pin-tail {\n  position: absolute;\n  left: 50%;\n  bottom: 5px;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  transform: translateX(-50%);\n}\n\n.pin-icon {\n  position: absolute;\n  width: 34px;\n  height: 34px;\n  top: 3px;\n  left: 50%;\n  transform: translateX(-50%);\n  filter: brightness(0) invert(1);\n  pointer-events: none;\n  object-fit: contain;\n}\n\n/* Dark Mode Global Support & PrimeReact overrides */\n[data-theme='dark'] body,\nbody[data-theme='dark'] {\n  background-color: #0f1719;\n  color: #f1f5f9;\n}\n\n/* PrimeReact Dropdown Dark Mode */\n[data-theme='dark'] .tele-dropdown,\n[data-theme='dark'] .p-dropdown {\n  background-color: rgba(255, 255, 255, 0.05) !important;\n  border-color: rgba(255, 255, 255, 0.16) !important;\n  color: #f1f5f9 !important;\n}\n\n[data-theme='dark'] .tele-dropdown .p-dropdown-label,\n[data-theme='dark'] .p-dropdown .p-dropdown-label {\n  color: #f1f5f9 !important;\n}\n\n[data-theme='dark'] .tele-dropdown .p-dropdown-trigger,\n[data-theme='dark'] .p-dropdown .p-dropdown-trigger {\n  color: #94a3b8 !important;\n}\n\n[data-theme='dark'] .tele-dropdown-label,\n[data-theme='dark'] .p-float-label label {\n  color: #94a3b8 !important;\n}\n\n[data-theme='dark'] .tele-dropdown-panel,\n[data-theme='dark'] .p-dropdown-panel {\n  background-color: #172328 !important;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6) !important;\n}\n\n[data-theme='dark'] .tele-dropdown-panel .p-dropdown-item,\n[data-theme='dark'] .p-dropdown-panel .p-dropdown-item {\n  color: #f1f5f9 !important;\n}\n\n[data-theme='dark'] .tele-dropdown-panel .p-dropdown-item:hover,\n[data-theme='dark'] .p-dropdown-panel .p-dropdown-item:hover,\n[data-theme='dark'] .p-dropdown-panel .p-dropdown-item.p-highlight {\n  background-color: rgba(255, 255, 255, 0.08) !important;\n  color: #ffffff !important;\n}\n\n[data-theme='dark'] .p-dropdown-panel .p-dropdown-header,\n[data-theme='dark'] .tele-dropdown-panel .p-dropdown-header,\n[data-theme='dark'] .p-dropdown-header,\n[data-theme='dark'] .p-multiselect-panel .p-multiselect-header,\n[data-theme='dark'] .p-multiselect-header,\nbody[data-theme='dark'] .p-dropdown-panel .p-dropdown-header,\nbody[data-theme='dark'] .tele-dropdown-panel .p-dropdown-header,\nbody[data-theme='dark'] .p-dropdown-header,\nbody[data-theme='dark'] .p-multiselect-panel .p-multiselect-header,\nbody[data-theme='dark'] .p-multiselect-header {\n  background: #172328 !important;\n  background-color: #172328 !important;\n  color: #f1f5f9 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter,\n[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter,\nbody[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter,\nbody[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter {\n  background-color: #243238 !important;\n  color: #f1f5f9 !important;\n  border: 1px solid rgba(255, 255, 255, 0.18) !important;\n  border-radius: 4px !important;\n  padding: 6px 10px !important;\n  outline: none !important;\n}\n\n[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter::placeholder,\n[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter::placeholder,\nbody[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter::placeholder,\nbody[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter::placeholder {\n  color: #8fa3ad !important;\n  opacity: 0.85 !important;\n}\n\n[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter:focus,\n[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter:focus,\nbody[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter:focus,\nbody[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter:focus {\n  background-color: #2c3b42 !important;\n  border-color: #38bdf8 !important;\n  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25) !important;\n}\n\n[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter-icon,\n[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter-icon,\nbody[data-theme='dark'] .p-dropdown-filter-container .p-dropdown-filter-icon,\nbody[data-theme='dark'] .p-multiselect-filter-container .p-multiselect-filter-icon {\n  color: #8fa3ad !important;\n}\n\n[data-theme='dark'] .p-dropdown-clearable-filter .p-dropdown-filter-clear-icon,\nbody[data-theme='dark'] .p-dropdown-clearable-filter .p-dropdown-filter-clear-icon {\n  color: #8fa3ad !important;\n}\n\n/* PrimeReact Calendar Dark Mode */\n[data-theme='dark'] .p-datepicker {\n  background-color: #172328 !important;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  color: #f1f5f9 !important;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6) !important;\n}\n\n[data-theme='dark'] .p-datepicker table th,\n[data-theme='dark'] .p-datepicker table td > span {\n  color: #f1f5f9 !important;\n}\n\n[data-theme='dark'] .p-datepicker .p-datepicker-header {\n  background-color: #172328 !important;\n  color: #f1f5f9 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;\n}\n\n[data-theme='dark'] .p-datepicker table td > span:hover {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n/* Dark scrollbars */\n[data-theme='dark'] ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n[data-theme='dark'] ::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n[data-theme='dark'] ::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n}\n\n[data-theme='dark'] ::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n/* Native Leaflet Dark Theme via CSS filters (No external tile providers or API keys needed) */\n[data-theme='dark'] .leaflet-tile-pane {\n  filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%);\n}\n\n[data-theme='dark'] .no-map-dark-filter .leaflet-tile-pane {\n  filter: none !important;\n}\n\n[data-theme='dark'] .leaflet-container {\n  background-color: #0b1114 !important;\n}\n\n[data-theme='dark'] .leaflet-bar a {\n  background-color: #162328 !important;\n  color: #f1f5f9 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;\n}\n\n[data-theme='dark'] .leaflet-bar a:hover {\n  background-color: #23373e !important;\n  color: #ffffff !important;\n}\n\n[data-theme='dark'] .leaflet-control-attribution {\n  background-color: rgba(16, 26, 30, 0.8) !important;\n  color: #94a3b8 !important;\n}\n\n[data-theme='dark'] .leaflet-control-attribution a {\n  color: #38bdf8 !important;\n}\n\n[data-theme='dark'] .leaflet-control-layers {\n  background-color: #162328 !important;\n  color: #f1f5f9 !important;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5) !important;\n}\n\n[data-theme='dark'] .leaflet-control-layers-toggle {\n  filter: brightness(0.9) invert(0.9);\n}\n\n[data-theme='dark'] .leaflet-popup-content-wrapper,\n[data-theme='dark'] .leaflet-popup-tip {\n  background-color: #162328 !important;\n  color: #f1f5f9 !important;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;\n}\n\n[data-theme='dark'] .leaflet-container a.leaflet-popup-close-button {\n  color: #94a3b8 !important;\n}\n\n/* DataTables Column Filter Inputs - Base / Light Mode */\n.table-column-filter,\ntable.dataTable thead th input,\ntable.dataTable thead td input,\n.dataTables_wrapper thead input {\n  display: block;\n  box-sizing: border-box !important;\n  width: 100% !important;\n  margin-top: 6px !important;\n  padding: 4px 8px !important;\n  font-size: 12px !important;\n  font-family: inherit !important;\n  line-height: 1.4 !important;\n  border-radius: 4px !important;\n  border: 1px solid #cbd5e1 !important;\n  background-color: #ffffff !important;\n  color: #1e293b !important;\n  outline: none !important;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background-color 0.15s ease-in-out !important;\n}\n\n.table-column-filter::placeholder,\ntable.dataTable thead th input::placeholder,\ntable.dataTable thead td input::placeholder,\n.dataTables_wrapper thead input::placeholder {\n  color: #94a3b8 !important;\n  opacity: 1 !important;\n}\n\n.table-column-filter:focus,\ntable.dataTable thead th input:focus,\ntable.dataTable thead td input:focus,\n.dataTables_wrapper thead input:focus {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2) !important;\n}\n\n/* DataTables Column Filter Inputs - Dark Mode Grayish Theme */\n[data-theme='dark'] .table-column-filter,\n[data-theme='dark'] table.dataTable thead th input,\n[data-theme='dark'] table.dataTable thead td input,\n[data-theme='dark'] .dataTables_wrapper thead input,\n[data-theme='dark'] .dataTables_wrapper .dataTables_filter input,\n[data-theme='dark'] input[placeholder=\"filtro\"],\nbody[data-theme='dark'] .table-column-filter,\nbody[data-theme='dark'] table.dataTable thead th input,\nbody[data-theme='dark'] table.dataTable thead td input,\nbody[data-theme='dark'] .dataTables_wrapper thead input,\nbody[data-theme='dark'] input[placeholder=\"filtro\"] {\n  background-color: #243238 !important;\n  color: #f1f5f9 !important;\n  border: 1px solid rgba(255, 255, 255, 0.18) !important;\n  border-radius: 4px !important;\n  box-sizing: border-box !important;\n  padding: 4px 8px !important;\n  font-size: 12px !important;\n  outline: none !important;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25) !important;\n  transition: border-color 0.15s ease-in-out, background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n\n[data-theme='dark'] .table-column-filter::placeholder,\n[data-theme='dark'] table.dataTable thead th input::placeholder,\n[data-theme='dark'] table.dataTable thead td input::placeholder,\n[data-theme='dark'] .dataTables_wrapper thead input::placeholder,\n[data-theme='dark'] .dataTables_wrapper .dataTables_filter input::placeholder,\n[data-theme='dark'] input[placeholder=\"filtro\"]::placeholder,\nbody[data-theme='dark'] input[placeholder=\"filtro\"]::placeholder {\n  color: #8fa3ad !important;\n  opacity: 0.85 !important;\n}\n\n[data-theme='dark'] .table-column-filter:hover,\n[data-theme='dark'] table.dataTable thead th input:hover,\n[data-theme='dark'] table.dataTable thead td input:hover,\n[data-theme='dark'] .dataTables_wrapper thead input:hover,\n[data-theme='dark'] .dataTables_wrapper .dataTables_filter input:hover,\n[data-theme='dark'] input[placeholder=\"filtro\"]:hover,\nbody[data-theme='dark'] input[placeholder=\"filtro\"]:hover {\n  background-color: #2c3b42 !important;\n  border-color: rgba(255, 255, 255, 0.28) !important;\n}\n\n[data-theme='dark'] .table-column-filter:focus,\n[data-theme='dark'] table.dataTable thead th input:focus,\n[data-theme='dark'] table.dataTable thead td input:focus,\n[data-theme='dark'] .dataTables_wrapper thead input:focus,\n[data-theme='dark'] .dataTables_wrapper .dataTables_filter input:focus,\n[data-theme='dark'] input[placeholder=\"filtro\"]:focus,\nbody[data-theme='dark'] input[placeholder=\"filtro\"]:focus {\n  background-color: #31444e !important;\n  border-color: #38bdf8 !important;\n  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25) !important;\n  color: #ffffff !important;\n}\n\n/* DataTables Wrapper Controls in Dark Mode */\n[data-theme='dark'] .dataTables_wrapper .dataTables_length select,\nbody[data-theme='dark'] .dataTables_wrapper .dataTables_length select {\n  background-color: #243238 !important;\n  color: #f1f5f9 !important;\n  border: 1px solid rgba(255, 255, 255, 0.18) !important;\n  border-radius: 4px !important;\n  padding: 3px 6px !important;\n  outline: none !important;\n}\n\n[data-theme='dark'] .dataTables_wrapper .dataTables_length,\n[data-theme='dark'] .dataTables_wrapper .dataTables_filter,\n[data-theme='dark'] .dataTables_wrapper .dataTables_info,\n[data-theme='dark'] .dataTables_wrapper .dataTables_processing,\n[data-theme='dark'] .dataTables_wrapper .dataTables_paginate {\n  color: #94a3b8 !important;\n}\n\n[data-theme='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button {\n  color: #cbd5e1 !important;\n}\n\n[data-theme='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.current,\n[data-theme='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {\n  background: #243238 !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  color: #ffffff !important;\n}\n\n[data-theme='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  background: rgba(255, 255, 255, 0.08) !important;\n  border: 1px solid transparent !important;\n  color: #ffffff !important;\n}\n\n[data-theme='dark'] table.dataTable thead th,\n[data-theme='dark'] table.dataTable thead td {\n  color: #f1f5f9 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;\n}\n\n[data-theme='dark'] table.dataTable tbody tr {\n  background-color: transparent !important;\n  color: #e2e8f0 !important;\n}\n\n[data-theme='dark'] table.dataTable.stripe tbody tr.odd,\n[data-theme='dark'] table.dataTable.display tbody tr.odd {\n  background-color: rgba(255, 255, 255, 0.02) !important;\n}\n\n[data-theme='dark'] table.dataTable.hover tbody tr:hover,\n[data-theme='dark'] table.dataTable.display tbody tr:hover {\n  background-color: rgba(255, 255, 255, 0.06) !important;\n}\n\n/* Timeline and Dashboard Filters - Base / Light Mode */\n.timeline-filter-input,\n.timeline-date-input {\n  box-sizing: border-box;\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  color: #1e293b;\n  outline: none;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background-color 0.15s ease-in-out;\n}\n\n.timeline-filter-input::placeholder {\n  color: #94a3b8;\n  opacity: 1;\n}\n\n.timeline-filter-input:focus,\n.timeline-date-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n.timeline-date-label {\n  color: #64748b;\n}\n\n/* Timeline and Dashboard Filters - Dark Mode Grayish Theme */\n[data-theme='dark'] .timeline-filter-input,\n[data-theme='dark'] .timeline-date-input,\n[data-theme='dark'] input[placeholder*=\"Filtrar máquinas\"],\n[data-theme='dark'] input[placeholder*=\"filtrar máquinas\"],\nbody[data-theme='dark'] .timeline-filter-input,\nbody[data-theme='dark'] .timeline-date-input,\nbody[data-theme='dark'] input[placeholder*=\"Filtrar máquinas\"],\nbody[data-theme='dark'] input[placeholder*=\"filtrar máquinas\"] {\n  background-color: #243238 !important;\n  color: #f1f5f9 !important;\n  border: 1px solid rgba(255, 255, 255, 0.18) !important;\n  border-radius: 4px !important;\n  outline: none !important;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25) !important;\n  transition: border-color 0.15s ease-in-out, background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n\n[data-theme='dark'] .timeline-filter-input::placeholder,\n[data-theme='dark'] input[placeholder*=\"Filtrar máquinas\"]::placeholder,\n[data-theme='dark'] input[placeholder*=\"filtrar máquinas\"]::placeholder,\nbody[data-theme='dark'] .timeline-filter-input::placeholder,\nbody[data-theme='dark'] input[placeholder*=\"Filtrar máquinas\"]::placeholder,\nbody[data-theme='dark'] input[placeholder*=\"filtrar máquinas\"]::placeholder {\n  color: #8fa3ad !important;\n  opacity: 0.85 !important;\n}\n\n[data-theme='dark'] .timeline-filter-input:hover,\n[data-theme='dark'] .timeline-date-input:hover,\n[data-theme='dark'] input[placeholder*=\"Filtrar máquinas\"]:hover,\n[data-theme='dark'] input[placeholder*=\"filtrar máquinas\"]:hover,\nbody[data-theme='dark'] .timeline-filter-input:hover,\nbody[data-theme='dark'] .timeline-date-input:hover,\nbody[data-theme='dark'] input[placeholder*=\"Filtrar máquinas\"]:hover,\nbody[data-theme='dark'] input[placeholder*=\"filtrar máquinas\"]:hover {\n  background-color: #2c3b42 !important;\n  border-color: rgba(255, 255, 255, 0.28) !important;\n}\n\n[data-theme='dark'] .timeline-filter-input:focus,\n[data-theme='dark'] .timeline-date-input:focus,\n[data-theme='dark'] input[placeholder*=\"Filtrar máquinas\"]:focus,\n[data-theme='dark'] input[placeholder*=\"filtrar máquinas\"]:focus,\nbody[data-theme='dark'] .timeline-filter-input:focus,\nbody[data-theme='dark'] .timeline-date-input:focus,\nbody[data-theme='dark'] input[placeholder*=\"Filtrar máquinas\"]:focus,\nbody[data-theme='dark'] input[placeholder*=\"filtrar máquinas\"]:focus {\n  background-color: #31444e !important;\n  border-color: #38bdf8 !important;\n  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25) !important;\n  color: #ffffff !important;\n}\n\n[data-theme='dark'] .timeline-date-label,\nbody[data-theme='dark'] .timeline-date-label {\n  color: #94a3b8 !important;\n}\n\n[data-theme='dark'] input[type=\"date\"]::-webkit-calendar-picker-indicator,\nbody[data-theme='dark'] input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: invert(0.8);\n  cursor: pointer;\n}\n\n/* react-data-table-component Dark Mode */\n[data-theme='dark'] .rdt_Table,\nbody[data-theme='dark'] .rdt_Table {\n  background-color: transparent !important;\n  color: #f1f5f9 !important;\n}\n\n[data-theme='dark'] .rdt_TableHead,\nbody[data-theme='dark'] .rdt_TableHead {\n  background-color: transparent !important;\n  color: #f1f5f9 !important;\n}\n\n[data-theme='dark'] .rdt_TableHeadRow,\nbody[data-theme='dark'] .rdt_TableHeadRow {\n  background-color: rgba(255, 255, 255, 0.05) !important;\n  color: #f1f5f9 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;\n}\n\n[data-theme='dark'] .rdt_TableHeadRow div,\n[data-theme='dark'] .rdt_TableHeadRow span,\n[data-theme='dark'] .rdt_TableHeadRow p,\nbody[data-theme='dark'] .rdt_TableHeadRow div,\nbody[data-theme='dark'] .rdt_TableHeadRow span,\nbody[data-theme='dark'] .rdt_TableHeadRow p {\n  color: #f1f5f9 !important;\n}\n\n[data-theme='dark'] .rdt_TableBody,\nbody[data-theme='dark'] .rdt_TableBody {\n  background-color: transparent !important;\n}\n\n[data-theme='dark'] .rdt_TableRow,\nbody[data-theme='dark'] .rdt_TableRow {\n  background-color: #162328 !important;\n  color: #e2e8f0 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;\n}\n\n[data-theme='dark'] .rdt_TableRow:nth-of-type(even),\nbody[data-theme='dark'] .rdt_TableRow:nth-of-type(even) {\n  background-color: #131e23 !important;\n}\n\n[data-theme='dark'] .rdt_TableRow:hover,\nbody[data-theme='dark'] .rdt_TableRow:hover {\n  background-color: #1e2e34 !important;\n  color: #ffffff !important;\n}\n\n[data-theme='dark'] .rdt_TableCell,\nbody[data-theme='dark'] .rdt_TableCell {\n  color: #e2e8f0 !important;\n}\n\n[data-theme='dark'] .rdt_TableCell div,\n[data-theme='dark'] .rdt_TableCell span,\n[data-theme='dark'] .rdt_TableCell p,\nbody[data-theme='dark'] .rdt_TableCell div,\nbody[data-theme='dark'] .rdt_TableCell span,\nbody[data-theme='dark'] .rdt_TableCell p {\n  color: inherit;\n}\n\n[data-theme='dark'] .rdt_Pagination,\nbody[data-theme='dark'] .rdt_Pagination {\n  background-color: #162328 !important;\n  color: #94a3b8 !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.08) !important;\n}\n\n[data-theme='dark'] .rdt_Pagination svg,\nbody[data-theme='dark'] .rdt_Pagination svg {\n  fill: #cbd5e1 !important;\n}\n\n[data-theme='dark'] .rdt_Pagination button,\nbody[data-theme='dark'] .rdt_Pagination button {\n  color: #cbd5e1 !important;\n}\n\n[data-theme='dark'] .rdt_Pagination button:disabled svg,\nbody[data-theme='dark'] .rdt_Pagination button:disabled svg {\n  fill: rgba(255, 255, 255, 0.25) !important;\n}\n\n[data-theme='dark'] .rdt_Pagination select,\nbody[data-theme='dark'] .rdt_Pagination select {\n  background-color: #243238 !important;\n  color: #f1f5f9 !important;\n  border: 1px solid rgba(255, 255, 255, 0.18) !important;\n  border-radius: 4px !important;\n  padding: 3px 6px !important;\n  outline: none !important;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
